/**
 * Helper function to get multiple filter values from filter expressions
 * @param filterValues Array of filter objects with key and value that can be string or array
 * @param fieldName The field name to search for
 * @returns Array of extracted values for the specified field
 */
export const getCurrentFilterMultiValue = (
  filterValues: { key: string; value: string | string[] }[],
  fieldName: string
): string[] => {
  if (!fieldName) return [];

  return filterValues
    .filter(f => f.key === fieldName)
    .flatMap(f => {
      if (Array.isArray(f.value)) {
        return f.value;
      }

      const valueMatch = f.value.match(/\.eq\((.*?)\)$/);
      if (valueMatch && valueMatch[1]) {
        return valueMatch[1].replace(/^["']|["']$/g, '');
      }

      return f.value;
    });
};
